import type { ReactNode } from "react";
import { createContext, useContext } from "react";

const MemberFilterDesignContext = createContext<boolean>(false);

MemberFilterDesignContext.displayName = "MemberFilterDesignContext";

interface MemberFilterDesignProviderProps {
  children: ReactNode;
  enabled?: boolean;
}

export const MemberFilterDesignProvider = ({
  children,
  enabled = false,
}: MemberFilterDesignProviderProps) => (
  <MemberFilterDesignContext.Provider value={enabled}>
    {children}
  </MemberFilterDesignContext.Provider>
);

export const useMemberFilterDesign = () =>
  useContext(MemberFilterDesignContext);
